import React from 'react'

function money(value) {
  return `$${Math.round(Number(value || 0)).toLocaleString('es-AR')}`
}

export default function ResultHero({ haberBolsillo = 0, diferencialMensual = 0, retroactivoTotal = 0 }) {
  return (
    <section className="result-hero mt-4 rounded-2xl border border-cyan-200/30 bg-gradient-to-r from-cyan-500/15 via-blue-500/10 to-emerald-500/15 p-4 backdrop-blur-2xl">
      <p className="result-hero-label text-xs uppercase tracking-wide text-slate-300">Resumen Ejecutivo</p>
      <div className="mt-3 grid grid-cols-1 gap-3 md:grid-cols-3">
        <div className="result-hero-card rounded-xl border border-white/20 bg-white/10 p-3">
          <p className="result-hero-label text-[11px] uppercase tracking-wide text-slate-300">Haber de Bolsillo Reajustado</p>
          <p className="result-hero-value mt-1 text-2xl font-bold text-cyan-200">{money(haberBolsillo)}</p>
        </div>
        <div className="result-hero-card rounded-xl border border-white/20 bg-white/10 p-3">
          <p className="result-hero-label text-[11px] uppercase tracking-wide text-slate-300">Diferencial Mensual</p>
          <p className="result-hero-value mt-1 text-2xl font-bold text-amber-200">{money(diferencialMensual)}</p>
        </div>
        <div className="result-hero-card rounded-xl border border-white/20 bg-white/10 p-3">
          <p className="result-hero-label text-[11px] uppercase tracking-wide text-slate-300">Retroactivo Total</p>
          <p className="result-hero-value mt-1 text-2xl font-bold text-emerald-200">{money(retroactivoTotal)}</p>
        </div>
      </div>
    </section>
  )
}
